export const numerator = {
    value: '',
    unit: {},
    isRange: false,
    lowValue: '',
    highValue:'',
}